// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"ProductOptions__pc_only___3FOgn","sp_only":"ProductOptions__sp_only___3ZpEj","container":"ProductOptions__container___2DzZ-","btn":"ProductOptions__btn___2cDkv"};